const PopulationGrowth = () => {
  const data = [
    { rdate: '1980-01-01', year: '1980', rvalue: 34867, units: 'people', parameter: 'population', img_path: '/sites/default/files/pictures/1980.jpg', caption: 'Map Figure: 1980' },
    { rdate: '1990-01-01', year: '1990', rvalue: 60428, units: 'people', parameter: 'population', img_path: '/sites/default/files/pictures/1990.jpg', caption: 'Map Figure: 1990' },
    { rdate: '2000-01-01', year: '2000', rvalue: 119521, units: 'people', parameter: 'population', img_path: '/sites/default/files/pictures/2000.jpg', caption: 'Map Figure: 2000' },
    { rdate: '2010-01-01', year: '2010', rvalue: 205610, units: 'people', parameter: 'population', img_path: '/sites/default/files/pictures/2010.jpg', caption: 'Map Figure: 2010' },
    { rdate: '2015-01-01', year: '2015', rvalue: 216014, units: 'people', parameter: 'population', img_path: '/sites/default/files/pictures/2015.jpg', caption: 'Map Figure: 2015' },
  ];

  const popMap = document.querySelector('#pop-maps');
  const popMapImg = document.querySelector('.pop-map-img');
  const popMapTitle = document.querySelector('.pop-map-figure-title');
  popMapImg.setAttribute('src', '/sites/default/files/pictures/1980.jpg');

  const mousemove = (self, xScale) => {
    const x0 = parseInt(d3.mouse(self)[0]);
    const date = xScale.invert(d3.mouse(self)[0]);
    const year = moment(date).format('YYYY');
    
    const activeData = data.filter(d => d.year === year);

    if (activeData.length > 0) {
      popMapImg.setAttribute('src', activeData[0].img_path);
      // popMapTitle.textContent = activeData[0].year;
    }

  }

  const mouseout = () => {

  }

  const PopGraph = new LinePointArea({
    container: '#pop-graph',
    data,
    heightScale: 0.5,
    xAxis: {
      field: 'rdate',
      format: 'YYYY',
      scale: 'scaleTime',
    },
    yAxis: {
      field: 'rvalue',
      scale: 'scaleLinear',
      unitsField: 'units',
    },
    series: [
      { color: '#EC407A' },
    ],
    events: {
      mousemove,
      mouseout,
    }
  }).draw();
};
